import { Filter } from './filter.js';
import * as glMatrix from '../../../../node_modules/gl-matrix/esm';

export class SelectiveCorrectionFilter extends Filter {
    _useRelative: boolean;
    _redAdjust: glMatrix.vec4;
    _yellowAdjust: glMatrix.vec4;
    _greenAdjust: glMatrix.vec4;
    _cyanAdjust: glMatrix.vec4;
    _blueAdjust: glMatrix.vec4;
    _magentaAdjust: glMatrix.vec4;
    _whiteAdjust: glMatrix.vec4;
    _neutralAdjust: glMatrix.vec4;
    _blackAdjust: glMatrix.vec4;

    constructor(gl: any, width: number, height: number) {
        super(gl, width, height, 'selectiveCorrection', 'Correction Sélective');
        this.reset();
    }

    get useRelative() {
        return this._useRelative;
    }

    set useRelative(value) {
        var self = this;
        self._useRelative = value;
        self._touch = true;
    }

    get redAdjust() {
        return this._redAdjust;
    }

    set redAdjust(value) {
        var self = this;
        self._redAdjust = value;
        self._touch = true;
    }

    get yellowAdjust() {
        return this._yellowAdjust;
    }

    set yellowAdjust(value) {
        var self = this;
        self._yellowAdjust = value;
        self._touch = true;
    }

    get greenAdjust() {
        return this._greenAdjust;
    }

    set greenAdjust(value) {
        var self = this;
        self._greenAdjust = value;
        self._touch = true;
    }

    get cyanAdjust() {
        return this._cyanAdjust;
    }

    set cyanAdjust(value) {
        var self = this;
        self._cyanAdjust = value;
        self._touch = true;
    }

    get blueAdjust() {
        return this._blueAdjust;
    }

    set blueAdjust(value) {
        var self = this;
        self._blueAdjust = value;
        self._touch = true;
    }

    get magentaAdjust() {
        return this._magentaAdjust;
    }

    set magentaAdjust(value) {
        var self = this;
        self._magentaAdjust = value;
        self._touch = true;
    }

    get whiteAdjust() {
        return this._whiteAdjust;
    }

    set whiteAdjust(value) {
        var self = this;
        self._whiteAdjust = value;
        self._touch = true;
    }

    get neutralAdjust() {
        return this._neutralAdjust;
    }

    set neutralAdjust(value) {
        var self = this;
        self._neutralAdjust = value;
        self._touch = true;
    }

    get blackAdjust() {
        return this._blackAdjust;
    }

    set blackAdjust(value) {
        var self = this;
        self._blackAdjust = value;
        self._touch = true;
    }

    reset() {
        var self = this;
        self._useRelative = true;
        self._redAdjust = glMatrix.vec4.create();
        self._yellowAdjust = glMatrix.vec4.create();
        self._greenAdjust = glMatrix.vec4.create();
        self._cyanAdjust = glMatrix.vec4.create();
        self._blueAdjust = glMatrix.vec4.create();
        self._magentaAdjust = glMatrix.vec4.create();
        self._whiteAdjust = glMatrix.vec4.create();
        self._neutralAdjust = glMatrix.vec4.create();
        self._blackAdjust = glMatrix.vec4.create();
    }

}
